import queryString from 'query-string';

const cakePixel = () => {
  const parsed = queryString.parse(
    typeof window !== 'undefined' ? window.location.search : ''
  );
  const { o, a, s1, s2, s3, s4, s5, c, cpid, p, req_id } = parsed;
  const cakeParams = `&o=${o || ''}&a=${a || ''}&s1=${s1 || ''}&s2=${
    s2 || ''
  }&s3=${s3 || ''}&s4=${s4 || ''}&s5=${s5 || ''}&c=${c || ''}&cpid=${
    cpid || ''
  }&p=${p || ''}`;
  const cakeDomain = 'suited45trk.com/?cp=js';

  const src = `https://${cakeDomain}&${cakeParams}`;

  return new Promise((resolve, reject) => {
    if (req_id === null || req_id === '' || req_id === undefined) {
      if (
        o !== undefined &&
        a !== undefined &&
        c !== undefined &&
        cpid !== undefined
      ) {
        let script = document.createElement('script');
        script.src = src;
        script.addEventListener('load', () => resolve());
        script.addEventListener('error', (e) => reject(e));
        document.body.appendChild(script);
        console.log(src);
      } else {
        const defaultSrc =
          'https://approvedtk.com/?f5c=bFwxX1qWpTlBzYXKe02E7Q%3d%3d&cp=js&s1=SUB_ID';
        let script = document.createElement('script');
        script.src = defaultSrc;
        script.addEventListener('load', () => resolve());
        script.addEventListener('error', (e) => reject(e));
        document.body.appendChild(script);
        console.log(defaultSrc);
      }
    } else {
      console.log('ReqID in URL');
      resolve();
    }
  });
};

export default cakePixel;
